import { ResetPassword } from './../../core/models/resetPassword.model';
import { NgForm, Validators, FormControl } from '@angular/forms';
import { AuthService } from '../../core/services/acceso/auth.service';
import { Route, ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  BootstrapAlertComponent,
  EAlertType
} from '../../components/bootstrap-alert/bootstrap-alert.component';
import { Configuration } from '../../core/configuration/configuration';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { PathRoutes } from '../../core/configuration/pathRoutes';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordModel: ResetPassword = new ResetPassword();
  @ViewChild(BootstrapAlertComponent)
  bootstrapAlertComponent: BootstrapAlertComponent;

  loading: boolean;
  password: string;
  confirmPassword: string;
  titulo: string;
  textButton: string;
  passwordPattern = Configuration.passwordRegExPattern;

  constructor(
    private _activatedRoute: ActivatedRoute,
    protected _router: Router,
    private _authService: AuthService,
    private _messageDialog: MessageDialog
  ) {}

  ngOnInit() {
    this._activatedRoute.queryParams.subscribe(params => {
      this.resetPasswordModel.Code = params['code'];
    });

    if(this._activatedRoute.snapshot.routeConfig.path === PathRoutes.finalizeRegister){
      this.titulo = 'Establecer contraseña';
      this.textButton = 'completar registro'
    }
    else{
      this.titulo = 'Recuperación de contraseña';
      this.textButton ='Cambiar contraseña';
    }
  }

  onSubmit() {
    this.loading = true;
    this._authService.resetPassword(this.resetPasswordModel).subscribe(
      res => {
        this._messageDialog.ShowMessage(
          'Su contraseña se ha actualizado correctamente',
          ''
        );
        this.loading = false;
        this._router.navigate([`../${PathRoutes.login}`],  {relativeTo: this._activatedRoute});
      },
      err => {
        this._messageDialog.ShowAlert(
          'No se ha podido actualizar su contraseña',
          'Error'
        );
        console.error(err);
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }
}
